<script setup>
import { computed, ref } from 'vue';
import util from '@/util';
import store from '@/store';
import ButtonGroup from '@/component/ButtonGroup.vue';
import { CONTEXT } from '@/const';

const showHelpGuide = computed(() => store.state.appPolicy.otherSettings?.showHelpGuide);
const showPrivacyStatement = computed(
  () => store.state.appPolicy.otherSettings?.showPrivacyStatement
);
const buttons = ref([
  {
    text: 'button.problem',
    visible: showHelpGuide,
    onClick: () => util.jumpTo(`${CONTEXT.uniportal}/help.html`),
  },
  {
    text: 'button.privacyPolicy',
    visible: showPrivacyStatement,
    onClick: () =>
      util.jumpTo(`${CONTEXT.uniportal}/privacyPolicyInter.html`, {
        redirect: util.getURLSearchParam('redirect'),
      }),
  },
  {
    text: 'Cookies',
    visible: true,
    onClick: () =>
      window.open(`${CONTEXT.uniportal}/cookie-statements.html${location.search}`, '_blank'),
  },
]);
</script>

<template>
  <button-group class="mt-7 px-5" :buttons="buttons"></button-group>
</template>

<style scoped lang="less"></style>
